module.exports = __webpack_public_path__ + "img/icon-security.a97ffe1f.svg";